var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.753,
    height: 9.835,
    viewBox: "0 0 14.753 9.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.002 -85.334)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.002 85.334)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1,89.022H9.223a.615.615,0,1,0,0-1.229H2.1l1.409-1.409a.615.615,0,0,0-.869-.869L.182,87.973q-.021.021-.041.045l-.016.022-.019.026-.016.027-.015.025c0,.009-.009.019-.013.028l-.012.027c0,.009-.007.018-.01.028s-.007.019-.01.029,0,.019-.007.028-.005.02-.007.03,0,.022,0,.033,0,.018,0,.027a.619.619,0,0,0,0,.121c0,.009,0,.018,0,.027s0,.022,0,.033,0,.02.007.03,0,.019.007.028.007.02.01.029.006.018.01.028.008.018.012.027l.013.028.015.025.016.027.019.026.016.022q.019.023.04.045h0L2.641,91.3a.615.615,0,0,0,.869-.869Z",
    transform: "translate(-0.002 -85.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.363,216.8l.016-.022.019-.026.016-.027.015-.025c0-.009.009-.019.014-.028l.012-.027c0-.009.007-.018.01-.028s.007-.019.01-.029,0-.019.007-.028.005-.02.007-.03,0-.022,0-.033,0-.018,0-.027a.618.618,0,0,0,0-.121c0-.009,0-.018,0-.027s0-.022,0-.033,0-.02-.007-.03,0-.019-.007-.028-.007-.02-.01-.029-.006-.018-.01-.028l-.012-.027c0-.009-.009-.019-.014-.028l-.015-.025-.016-.027-.019-.026-.016-.022q-.019-.023-.04-.044h0l-2.459-2.459a.615.615,0,1,0-.869.869L178.4,215.8h-7.122a.615.615,0,0,0,0,1.229H178.4l-1.409,1.409a.615.615,0,1,0,.869.869l2.459-2.459h0Q180.344,216.823,180.363,216.8Z",
    transform: "translate(-165.749 -209.648)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap-icon.0c17f363c1e0c7f35e36e4c7500bdbb7.svg";
export { ForwardRef as ReactComponent };